// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1I-rh","legacyBtn":"MutateMid_legacyBtn__16-Mz"};